module.exports = __webpack_public_path__ + "media/images/payments/laser-214fc582eefd2adc4b3e82c766f6d104.svg";